import React, { useEffect, useState } from 'react'
import './style.css'
import { Link, NavLink, useLocation, useNavigate } from 'react-router-dom';

const Navbar = () => {
    // const [active, setActive] = useState('')
    useEffect(()=>{
        const nav = document.querySelector('.navbarMain');
        let lastScrollY = window.scrollY; 
        window.addEventListener('scroll',()=>{
          if(lastScrollY < window.scrollY){
            nav.classList.add('navbarMain--hidden');
          }else{
            nav.classList.remove('navbarMain--hidden');
          }  
          lastScrollY =window.scrollY 
        })  
    })

    const navigate = useNavigate()

    const routs = (el)=>{ 
        navigate(el) 
    }

    const location = useLocation();

    // Logic to determine if a link is active
    const isActiveLink = (link) => {
      return link === location.pathname;
    };

    // console.log(active);
  return (
    <div className='navbarMain ' style={{width:'100%'}}> 
        <div style={{width:'95%', margin:'auto'}}>
            <div className='d-flex align-items-center justify-content-between mainNav'>
                <div className='d-flex align-items-center p-2'>
                      <img onClick={()=>routs("/")} style={{height:'65px',cursor:'pointer'}} src={require("../images/home/logo.png")} alt="" />
                </div>
                <div className='d-flex gap-3 align-items-center'>
                    <div className='decktopNav'>
                        <ul className='d-flex gap-5 m-0 mt-3' style={{listStyle:'none',fontSize:'14px',fontWeight:'500',color:'gray'}}>
                            <li> 
                               <p style={{cursor:'pointer'}} className=' '><span><i className="bi bi-telephone-fill text-danger"></i></span> <span>+91-9510212744</span></p> 
                            </li>
                            <li>
                               <p style={{cursor:'pointer'}} className=' '><span><i className="bi bi-clock text-danger"  ></i></span> <span className='mx-1'> Mon - Fri 08:00 AM - 02:30 PM </span></p> 
                            </li>
                            <li>
                               <p style={{cursor:'pointer',maxWidth:'250px'}}  className=' text-start'><span><i className="bi bi-geo-alt-fill text-danger"></i></span> <a href='https://goo.gl/maps/NhaZd9DMb3Ryg1Et7' target='_blank' style={{textDecoration:'none'}} >Survey No. 510/4, Near D. Girish & Co., Lambhvel Road, Anand.</a></p> 
                            </li>
                            <li>
                                <button className='btn ' id='button' onClick={()=>navigate("/admission")}>Admissions</button>
                            </li>
                        </ul>
                    </div>
                    <div>
                        <button className='btn mobileNav' data-bs-toggle="offcanvas" href="#offcanvasHeader" role="button" aria-controls="offcanvasExample"><i className="bi bi-list"></i></button>
                    </div>

                    {/* mobile navbar start  */}
                    <div className="offcanvas offcanvas-end" tabIndex="-1" id="offcanvasHeader" aria-labelledby="offcanvasHeaderLabel">
                        <div className="offcanvas-header">
                            <div>
                            <img style={{height:'50px',cursor:'pointer'}}  data-bs-dismiss="offcanvas" aria-label="Close" src={require("../images/home/logo.png")} alt="" onClick={()=>routs("/")} />
                            </div>
                            <button type="button" className="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
                        </div>
                        <div className="offcanvas-body">
                            <div className='d-grid gap-2'> 
                                <div> 
                                    <button className={isActiveLink('/') ? 'active anibtn anibtn-left fs-5 p-0 my-2' : 'anibtn anibtn-left fs-5 p-0 my-2'}   data-bs-dismiss="offcanvas" aria-label="Close" onClick={()=>routs("/")}><span  >Home</span> </button>
                                </div>
                                <div>
                                    <button className={isActiveLink('/about') ? 'active anibtn anibtn-left fs-5 p-0 my-2' : 'anibtn anibtn-left fs-5 p-0 my-2'}    data-bs-dismiss="offcanvas" aria-label="Close" onClick={()=>routs("/about")}><span  >About</span></button>
                                </div>
                                <div>
                                    <button className={isActiveLink('/infrastructure') ? 'active anibtn anibtn-left fs-5 p-0 my-2' : 'anibtn anibtn-left fs-5 p-0 my-2'}  data-bs-dismiss="offcanvas" aria-label="Close" onClick={()=>routs("/infrastructure")}><span   >Infrastructure</span></button>
                                </div>
                                <div>
                                    <button className={isActiveLink('/faculty') ? 'active anibtn anibtn-left fs-5 p-0 my-2' : 'anibtn anibtn-left fs-5 p-0 my-2'}  data-bs-dismiss="offcanvas" aria-label="Close" onClick={()=>routs("/faculty")}><span >Faculty</span></button>
                                </div>
                                <div>
                                    <button className={isActiveLink('/activities') ? 'active anibtn anibtn-left fs-5 p-0 my-2' : 'anibtn anibtn-left fs-5 p-0 my-2'}  data-bs-dismiss="offcanvas" aria-label="Close" onClick={()=>routs("/activities")}><span >Activities</span></button>
                                </div>
                                <div>
                                    <button className={isActiveLink('/contacts') ? 'active anibtn anibtn-left fs-5 p-0 my-2' : 'anibtn anibtn-left fs-5 p-0 my-2'}  data-bs-dismiss="offcanvas" aria-label="Close" onClick={()=>routs("/contacts")}><span  >Contacts</span></button>
                                </div> 
                            </div>
                            <div>
                                <ul className='d-grid gap-3 text-center m-0 mt-3 p-0' style={{listStyle:'none',fontSize:'14px',fontWeight:'500',color:'gray'}}>
                                    <li>
                                    <p style={{cursor:'pointer'}} className=' '><span><i className="bi bi-telephone-fill text-danger"></i></span> <span>+91-9510212744</span></p> 
                                    </li>
                                    <li>
                                    <p style={{cursor:'pointer'}} className=' '><span><i className="bi bi-clock text-danger"  ></i></span> <span className='mx-1'> Mon - Fri 08:00 AM - 02:30 PM</span></p> 
                                    </li>
                                    <li>
                                    <p style={{cursor:'pointer'}} className='px-5'  ><span><i className="bi bi-geo-alt-fill text-danger"></i></span> <span >Survey No. 510/4, Near D. Grish & Co., Lambhvel road Anand.</span></p> 
                                    </li>
                                    <li>
                                        <button className='btn px-3 rounded-5 p-1 fw-semibold text-white' data-bs-dismiss="offcanvas" aria-label="Close" style={{background:'#215395'}} onClick={()=>navigate("/admission")}>Admissions</button>
                                    </li>
                                </ul>
                            </div>
                             
                        </div>
                    </div>
                    {/* mobile navbar end  */} 
                </div>
            </div>

            <hr className='decktopNav m-0'/>
            <div className='gap-4 decktopNav'>
                <div className='d-flex gap-4'> 
                 
                    <button className={isActiveLink('/') ? 'active anibtn anibtn-left fs-5 p-0 my-2' : 'anibtn anibtn-left fs-5 p-0 my-2'}   onClick={()=>routs("/")}> <span>Home</span> </button>
                    <button className={isActiveLink('/about') ? 'active anibtn anibtn-left fs-5 p-0 my-2' : 'anibtn anibtn-left fs-5 p-0 my-2'}   onClick={()=>routs("/about")}><span>About</span></button>
                    <button className={isActiveLink('/infrastructure') ? 'active anibtn anibtn-left fs-5 p-0 my-2' : 'anibtn anibtn-left fs-5 p-0 my-2'}   onClick={()=>routs("/infrastructure")}><span>Infrastructure</span></button>
                    <button className={isActiveLink('/faculty') ? 'active anibtn anibtn-left fs-5 p-0 my-2' : 'anibtn anibtn-left fs-5 p-0 my-2'}   onClick={()=>routs("/faculty")}><span>Faculty</span></button>
                    <button className={isActiveLink('/activities') ? 'active anibtn anibtn-left fs-5 p-0 my-2' : 'anibtn anibtn-left fs-5 p-0 my-2'}   onClick={()=>routs("/activities")}><span>Activities</span></button>
                    <button className={isActiveLink('/contacts') ? 'active anibtn anibtn-left fs-5 p-0 my-2' : 'anibtn anibtn-left fs-5 p-0 my-2'}   onClick={()=>routs("/contacts")}><span>Contacts</span></button>
                </div> 
            </div>
        </div>
    </div>
  )
}

export default Navbar